import React, { useEffect } from 'react'

const Privacy = () => {

    useEffect(() =>{
        window.scrollTo(0,0);       
   },[])

  return (
    <div className='privacyContainer'>
        <div className='backgroundPictures'>
            <div className='overlayP'>
            <div className='contentP'>
            <h1 id='privacyHeader'>Politique de confidentialité</h1>
            </div>
            </div>
        </div>
        <div className='privacyContainer2'>
            <h1 id='privacyHeader2'>Politique de confidentialité de Gara-Fashion</h1>
            <h3 id='privacyPoint1'>Dernière mise à jour : 01/03/2025</h3>
            <p>Chez Gara-Fashion Congo, nous accordons une grande importance à la protection de vos données personnelles. Cette politique de confidentialité explique comment nous recueillons, utilisons, et protégeons vos informations lorsque vous utilisez notre application de commerce électronique. En utilisant Gara-Fashion Congo, vous acceptez les pratiques décrites dans cette politique.</p>
            <div>
                <h3 id='privacyPoint'>
                1. Collecte des Informations
                </h3>
                <p>
                1.1 Nous recueillons les informations que vous nous fournissez directement, telles que lors de la création d'un compte, de l'achat de produits, ou de la communication avec notre service client.
                </p>
                <p id='paraPriva'> 1.2 Les types d'informations que nous pouvons recueillir comprennent : nom, adresse e-mail, numéro de téléphone, informations de paiement, et toute autre information que vous choisissez de nous fournir.</p>
            </div>

            <div>
                <h3 id='privacyPoint'>
                2. Utilisation des Informations
                </h3>
                <p>
                2.1 Nous utilisons vos informations pour :
        - Traiter vos commandes et gérer votre compte.
        - Communiquer avec vous concernant votre commande, votre compte ou toute autre demande.
        - Améliorer notre application et personnaliser votre expérience utilisateur.
        - Vous envoyer des offres promotionnelles, des mises à jour, et des newsletters (avec votre consentement).
        - Prévenir et détecter les fraudes et autres activités illégales.
        </p>
            </div>

            <div>
                <h3 id='privacyPoint'>
                3. Partage des Informations
                </h3>
                <p>
                3.1 Nous ne partageons pas vos informations personnelles avec des tiers, sauf dans les cas suivants :
        - Avec des prestataires de services tiers qui nous aident à exploiter notre application (par exemple, les services de paiement et de livraison).
        - Si requis par la loi ou pour se conformer à une procédure judiciaire.
        - Pour protéger nos droits, notre propriété, et la sécurité de nos utilisateurs.
        </p>
            </div>

            <div>
                <h3 id='privacyPoint'>
                4. Sécurité des Informations
                </h3>
                <p>
                4.1 Nous prenons des mesures de sécurité raisonnables pour protéger vos informations contre l'accès non autorisé, la divulgation, la modification ou la destruction. Cependant, aucune méthode de transmission sur Internet ou de stockage électronique n'est totalement sécurisée, et nous ne pouvons garantir une sécurité absolue.
                 </p>
            </div>

            <div>
                <h3 id='privacyPoint'>
                5. Vos Droits
                </h3>
                <p>
                5.1 Vous avez le droit d'accéder, de corriger, de mettre à jour ou de supprimer vos informations personnelles. Pour exercer ces droits, veuillez nous contacter sur facebook : Gara-Fashion Congo.
                 </p>
                 <p id='paraPriva'>5.2 Vous pouvez également refuser de recevoir des communications promotionnelles de notre part en suivant les instructions de désinscription incluses dans chaque e-mail.</p>
            </div>


            <div>
                <h3 id='privacyPoint'>
                6. Modifications de la Politique de Confidentialité
                </h3>
                <p>
                6.1 Nous pouvons mettre à jour cette politique de confidentialité de temps à autre pour refléter les changements apportés à nos pratiques ou pour d'autres raisons opérationnelles, légales ou réglementaires. Nous vous informerons de toute modification en publiant la nouvelle politique sur notre application et en mettant à jour la date de "dernière mise à jour".
                 </p>
                
            </div>

            <div>
                <h3 id='privacyPoint'>
                7. Contactez-nous
                </h3>
                <p>
                7.1 Si vous avez des questions ou des préoccupations concernant cette politique de confidentialité, veuillez nous contacter sur Facebook : Gara-Fashion Congo.
                 </p>
                
            </div>







        </div>
      
    </div>
  )
}

export default Privacy
